import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavItem, NavItemType } from '@core/layouts/menu-structure.service';
import { NavItemAccessService } from '@core/layouts/nav-item-access.service';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { PmIconComponent } from '@libs/ui';
import { BasicLayoutHelperService } from '../basic-layout-helper.service';

@Component({
  selector: 'pm-nav-item',
  templateUrl: './nav-item.component.html',
  imports: [
    CommonModule,
    InlineSVGModule,
    TranslateModule,
    CdkMenuModule,
    RouterLink,
    PmIconComponent,
  ],
})
export class NavItemComponent {
  @Input({ required: true }) navItem: NavItem;
  @Output() clickNavItem = new EventEmitter<void>();

  NavItemType = NavItemType;

  protected navItemAccessService = inject(NavItemAccessService);
  protected basicLayoutHelperService = inject(BasicLayoutHelperService);

  protected BACKGROUND_ACTIVE_CLASS =
    'bg-surface-interactive-active hover:bg-surface-interactive-active';
  protected BACKGROUND_DEFAULT_CLASS =
    'bg-white hover:bg-surface-interactive-hover';

  protected TEXT_ACTIVE_CLASS =
    'text-content-interactive-subdued-active group-hover:text-content-interactive-subdued-active';
  protected TEXT_DEFAULT_CLASS =
    'text-content-interactive-subdued group-hover:text-content-interactive-subdued-hover';
}
